import { useMutation } from "@tanstack/react-query";
import apiClient from "@apis/index";
import Routes from "@apis/routes";

export const useAskSupplier = () => {
  return useMutation({
    mutationFn: (data: {
      comments: string;
      location_id: number;
      price_mode: number;
      request_type: string;
      stock_item_id: number;
      additional_attributes: any;
    }) => apiClient.post(Routes.STOCK_ITEM_REQUEST, data),
  });
};
